import type { PortalWorkTicketDto } from "../model";

export interface DeliveryProgress {
	completed: number;
	total: number;
}

export function calculateDeliveryProgress(
	tickets: ReadonlyArray<Pick<PortalWorkTicketDto, "status"> & Partial<Pick<PortalWorkTicketDto, "isBlocked">>>,
): DeliveryProgress {
	return tickets.reduce<DeliveryProgress>(
		(progress, ticket) => {
			// Closed and cancelled are the durable out-of-scope and invalidated dispositions.
			if (ticket.status === "closed" || ticket.status === "cancelled") return progress;
			progress.total += 1;
			if (ticket.status === "resolved") progress.completed += 1;
			return progress;
		},
		{ completed: 0, total: 0 },
	);
}
